<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
        <el-input v-model="name" placeholder="请输入公司名称" @keyup.enter.native="getUsers"></el-input>
        <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="conpanys" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.uuid }}</span>
        </template>
      </el-table-column>

      <el-table-column label="姓名" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="邮箱" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.email }}</span>
        </template>
      </el-table-column>

      <el-table-column label="电话" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.mobile_number }}</span>
        </template>
      </el-table-column>

      <el-table-column label="印章ID" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.qianyue_seal_id }}</span>
        </template>
      </el-table-column>

      <el-table-column label="卡号" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.card_number }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
  import { getCompanyList } from '../../api/api';
  export default {
    created() {
      this.listLoading = true;
      //get list
      getCompanyList()
        .then((res) => {
          if(res.status === 0){
            this.conpanys = res.data.data;
            this.total_count = res.data.total_count;
            this.listLoading = false;
            if(res.data.total_pages  < 2){
              this.pagination = false;
            }
          }else if ( res.status === 1){
            this.$message({
                message: res.status_text,    
           });
            this.listLoading = false;
          }
        })
    },
    beforeRouteUpdate(to, from, next) {
      this.listLoading = true;
      //get list
      getCompanyList(to.query)
        .then((res) => {
          if(res.status === 0){
            this.conpanys = res.data.data;
            this.total_count = res.data.total_count;
            this.listLoading = false;
            if(res.data.total_pages < 2){
              this.pagination = false;
            }
          }
        })
    },
    data() {
      return {
        name: '',
        currentPage: 1,
        conpanys: [],
        listLoading: false,
        total_count: 0,
        pagination: true
      }
    },
    methods: {
      getUsers() {
        let params = {
          'search[name]': this.name,
          'page': this.currentPage
        };
        getCompanyList(params).then((res) => {
          if(res.status === 0){
            this.conpanys = res.data.data;
            this.total_count = res.data.total_count;
            if(res.data.total_pages < 2){
              this.pagination = false;
            }else {
              this.pagination = true;
            }
          }
        })
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getUsers();
      },
    }
  }

</script>

<style lang="scss">
@import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/Companies.vue